import { styled } from "@mui/material";

export const StyledHeader = styled("div")(
  ({ theme }) => `
    position: relative;
    overflow: visible;
    .appbar {
      top: 0px;
      left: 0px;
      width: 100%;
      z-index: 10;
      background: transparent;
      box-shadow: none;
      position: -webkit-sticky !important;
    }
    .toolbar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 6%;
      background-color: white;
    }
    .header-right-section {
      display: flex;
      gap: 30px;
      align-items: center;
      @media screen and (max-width: 1024px) {
        display: none;
      }
    }
    .header-links {
      display: flex;
      gap: 30px;
      align-items: center;
    }
    .header-btns {
      display: flex;
      gap: 15px;
      align-items: center;
    }
    .link-text {
      font-family: Lexend;
      color: ${theme.palette.primary.main};
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      text-decoration: none;
    }
      .link-text:hover {
        text-decoration: underline;
      }
    .login-btn {
      background-color: black;
      color: white;
      border-radius: 0px;
      padding: 7px 20px;
      font-family: Lexend;
      text-transform: none;
    }
      .login-btn:hover {
        transform: scale(1.1);
      }
    .signup-btn {
      border: 1px solid ${theme.palette.primary.main};
      border-radius: 0px;
      padding: 6px 20px;
      font-family: Lexend;
      text-transform: none;
    }
      .signup-btn:hover {
        transform: scale(1.1);
      }
    .hanberger-icon {
      display: none;
      @media screen and (max-width: 1024px) {
        display: block;
      }
    }
    .logo {
      height: 20px;
       @media screen and (max-width: 1024px) {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: -14px;
      }
    }
    .profile-button {
      position: relative;
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
    }
    .icon-background {
      font-size: 22px;
      color: ${theme.palette.primary.main};
    }
    .userName {
      font-family: Lexend;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      color: ${theme.palette.primary.main};
    }        
  `
);

export const StyledDrawer = styled("div")(
  ({ theme }) => `
    .mobile-layout {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100vh;
    }
    .drawer-item-list {
      width: 100vw;
      display: flex;
      flex-direction: column;
    }
    .drawer-header {
      align-items: center;
      justify-content: center;
      position: relative;
      padding: 20px 0px;
      margin-bottom: 20px;
      display: flex;
    }
    .iconClass {
      position: absolute;
      left: 0;
    }
    .drawer-item-list a {
      color: ${theme.palette.primary.main};
      font-family: Lexend;
      font-size: 16px;
      padding: 8px 16px;
      text-decoration: none;
    }

    .logo {
      height: 20px;
    }
  `
);
